const COLORS = {
    initializing: "bg-stone-200 text-ink",
    ringing: "bg-amber-500 text-white",
    connected: "bg-emerald-500 text-white",
    completed: "bg-stone-900 text-white",
    failed: "bg-red-500 text-white",
    "no-answer": "bg-red-400 text-white",
    idle: "bg-stone-200 text-ink",
};

export default function StatusPill({ status = "idle", testId }) {
    const cls = COLORS[status] || COLORS.idle;
    const pulse = status === "ringing" || status === "connected";
    return (
        <span
            data-testid={testId || `status-${status}`}
            className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] ${cls}`}
        >
            {pulse && (
                <span className="relative grid h-2 w-2 place-items-center">
                    <span className="absolute h-2 w-2 animate-pulse-ring rounded-full bg-white/70" />
                    <span className="h-2 w-2 rounded-full bg-white" />
                </span>
            )}
            {status.replace("-", " ")}
        </span>
    );
}
